/**
 * Reusable campaign body component
 * Provides consistent body layout for campaign sections
 */
import { type FC, memo, type ReactNode } from 'react';
import { useCampaignSectionBase } from '../../_hooks/useCampaignSection';
import CampaignSectionBackground from '../CampaignSectionBackground/CampaignSectionBackground';
import styles from './CampaignSectionBody.modules.css';

interface CampaignBodyProps {
  sectionName: string;
  isActive: boolean;
  backgroundImage?: string;
  backgroundColor?: string;
  children: ReactNode;
  additionalProps?: Record<string, unknown>;
  isSingleItem?: boolean;
}

const CampaignSectionBody: FC<CampaignBodyProps> = ({
  sectionName,
  isActive,
  backgroundImage,
  backgroundColor,
  children,
  additionalProps,
  isSingleItem = false
}) => {
  const { createContainerProps } = useCampaignSectionBase({ name: sectionName }, isActive);
  
  const containerProps = createContainerProps({
    'data-one-item': isSingleItem ? 'true' : 'false',
    ...additionalProps
  });

  return (
    <div className={styles.CampaignSectionBody} {...containerProps}>
      <CampaignSectionBackground
        backgroundImage={backgroundImage}
        backgroundColor={backgroundColor}
        sectionName={sectionName}
        isActive={isActive}
        additionalProps={additionalProps}
      />
      {children}
    </div>
  );
};

export default memo(CampaignSectionBody);
